<template>
  <div>

      <div class="result">
        <div class="icons">
          <i class="el-icon-success"/>
        </div>
        <div class="title">Password changed successfully</div>

        <div class="action">
          <div class="toLogin">
            <h3>Will return to the login page in <span>{{time}}</span>seconds.</h3>
          </div>
        </div>
      </div>


  </div>
</template>

<script>
import { postAction, getAction } from '@/api/manage.js';
import Vue from 'vue'
  export default {
    name: "Step4",
    props:['userInfo','finish'],

    data () {
      return {
        loading: false,
        time: 0,
      }
    },
    methods: {
      countDown(){
        let that = this;
        that.time--;
      }
    },
    async mounted(){
      let that = this;
      that.time = 3;
      let res = await postAction('/sys/login', {
        password: this.userInfo.password,
        remember_me: false,
        username: this.userInfo.email,
        loginEntry: 1
      });
      if (res.code == 200) {
        this.$ls.set('token', res.result.token);
        this.$ls.set('userInfo', res.result.userInfo);
        this.$ls.set('realname', res.result.userInfo.realname);
        Vue.prototype.login=true;

      }

      let st = setInterval(()=>{
        if(that.time==0){
          clearInterval(st)
        }else{
          that.time--;
        }

      }, 1000);
    },
    watch: {
      time: function (newVal,oldVal) {
        if (newVal == 0) {
          var params = {
            username: this.userInfo.username
          };
          //this.$emit('finish')
          this.$router.push('/')
        }
      }
    }
  }
</script>
<style scoped>
  .icons{
    text-align: center;
    font-size: 60px;
    color: #52C41A;
  }
  .result {
    text-align: center;
    width: 72%;
    margin: 0 auto;
    padding: 24px 0 8px;

    .icon {
      font-size: 72px;
      line-height: 72px;
      margin-bottom: 24px;
    }
    .success {
      color: #52c41a;
    }
    .error {
      color: red;
    }
    .title {
      font-size: 24px;
      color: rgba(0, 0, 0, .85);
      font-weight: 500;
      line-height: 32px;
      margin-bottom: 16px;
    }
    .description {
      font-size: 14px;
      line-height: 22px;
      color: rgba(0, 0, 0, 0.45);
      margin-bottom: 24px;
    }
    .content {
      background: #fafafa;
      padding: 24px 40px;
      border-radius: 2px;
      text-align: left;
    }
    .action {
      margin-top: 32px;
    }
  }

  .mobile {
    .result {
      width: 100%;
      margin: 0 auto;
      padding: unset;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/forget/Step4.vue